import { Link } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { PageMeta } from "@/components/shared/PageMeta"
import { PAGE_SEO } from "@/lib/seo"

export default function NotFoundPage(): React.JSX.Element {
	return (
		<>
			<PageMeta {...PAGE_SEO.notFound} noIndex />
			<div className="mx-auto max-w-xl px-4 py-24 text-center">
				<h1 className="text-5xl font-bold text-primary">404</h1>
				<p className="mt-4 text-lg text-muted-foreground">La página que buscas no existe.</p>
				<Button asChild className="mt-8">
					<Link to="/">Volver al inicio</Link>
				</Button>
			</div>
		</>
	)
}
